// axios
import axios from "axios";

const domain = process.env.VUE_APP_GRAPHQL_DEFAULT_ENDPOINT;
const token = localStorage.getItem("accessToken");

export default axios.create({
	baseURL: domain,
	headers: { token: `${token}` }
	// You can add your headers here
});
